var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"firebaseui-auth-container"}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("You are Logging from "+_vm._s(_vm.country_name))]),(_vm.notFound)?_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("No country found, please select manually")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }